import { render } from "./feature-area.vue?vue&type=template&id=e813bc78&scoped=true"
import script from "./feature-area.vue?vue&type=script&lang=js"
export * from "./feature-area.vue?vue&type=script&lang=js"

import "./feature-area.vue?vue&type=style&index=0&id=e813bc78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e813bc78"]])

export default __exports__